import React from 'react'
import { Divider, ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { useColorScheme } from '@mui/material/styles'
import LightModeIcon from '@mui/icons-material/LightMode'
import DarkModeIcon from '@mui/icons-material/DarkMode'
import SettingsBrightnessIcon from '@mui/icons-material/SettingsBrightness'
import CheckIcon from '@mui/icons-material/Check'
import { useAppTranslations } from '../../utils/hooks/useAppTranslations'
import { startThemeTransition } from '../../styles/theme/themeTransition'

type ThemeMode = 'light' | 'dark' | 'system'

interface ThemeModeMenuSectionProps {
  onSelect?: (event: React.SyntheticEvent) => void
}

const themeModeOptions: { value: ThemeMode; labelKey: string; icon: React.ReactNode }[] = [
  { value: 'system', labelKey: 'layout.theme.system', icon: <SettingsBrightnessIcon fontSize="small" /> },
  { value: 'light', labelKey: 'layout.theme.light', icon: <LightModeIcon fontSize="small" /> },
  { value: 'dark', labelKey: 'layout.theme.dark', icon: <DarkModeIcon fontSize="small" /> },
]

const ThemeModeMenuSection: React.FC<ThemeModeMenuSectionProps> = ({ onSelect }) => {
  const t = useAppTranslations()
  const { mode, setMode } = useColorScheme()

  if (!mode) return null

  return (
    <>
      <Divider />
      <MenuItem disabled dense sx={{ opacity: '1 !important' }}>
        <ListItemText primary={t('layout.theme.label')} />
      </MenuItem>
      {themeModeOptions.map((option) => (
        <MenuItem
          key={option.value}
          selected={mode === option.value}
          onClick={(event) => {
            startThemeTransition()
            setMode(option.value)
            onSelect?.(event)
          }}
        >
          <ListItemIcon>{option.icon}</ListItemIcon>
          <ListItemText>{t(option.labelKey)}</ListItemText>
          {mode === option.value && (
            <ListItemIcon sx={{ minWidth: 'auto', pl: 1 }}>
              <CheckIcon fontSize="small" />
            </ListItemIcon>
          )}
        </MenuItem>
      ))}
    </>
  )
}

export default ThemeModeMenuSection
